import { getConfig } from '@superbet-group/web.lib.config';
import { createRestClient } from '@superbet-group/web.lib.rest';
import {
    createSimpleGetter,
    createSimpleMutator,
} from '@superbet-group/web.lib.vue-utilities';
import { ActionContext } from 'vuex';

import { IState } from '@app/store';
import { defaultHttpTimeoutMs } from '@core/constants';
import { createTvChannelsGetter } from '@sportOfferFederation/tvChannels/services';
import { TvChannelState } from '@sportOfferFederation/tvChannels/store/types';

function getDefaultState(): TvChannelState {
    return {
        betRadarIdToChannels: {},
    };
}

const mutationTypes = {
    SET_TV_CHANNELS: 'SET_TV_CHANNELS',
};

export default {
    namespaced: true,

    state: getDefaultState(),

    getters: {
        betRadarIdToChannels: createSimpleGetter<TvChannelState, 'betRadarIdToChannels'>('betRadarIdToChannels'),
    },

    mutations: {
        [mutationTypes.SET_TV_CHANNELS]: createSimpleMutator<TvChannelState, 'betRadarIdToChannels'>('betRadarIdToChannels'),
    },

    actions: {
        async fetchTvChannels(context: ActionContext<TvChannelState, IState>) {
            const host = getConfig().tvChannels.host;
            if (!host) {
                return;
            }

            const client = createRestClient(host, defaultHttpTimeoutMs);
            const getTvChannels = createTvChannelsGetter(client, getConfig().tvChannels.iconHost);
            const tvChannels = await getTvChannels(
                getConfig().tvChannels.country,
                getConfig().tvChannels.region,
            );

            context.commit(mutationTypes.SET_TV_CHANNELS, tvChannels);
        },
    },
};
